import type { PosMappingDto } from "../../types/PosMappingDto";
import type { PosMappingEntity } from "../../types/PosMappingEntity";

export const PosMappingDtoToEntity = ({ ...rest }: Readonly<PosMappingDto>): PosMappingEntity => {
    return { ...rest };
};
